import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {
      // Background 
      let HeaderHeight = 315
      
      this.canvasForm = this.svg
      .append('g')
      .attr('transform',`translate(0.5, 0.5)`)
      .style('font-family', 'roboto').style('cursor', 'default')

      // Header Summary

      this.status_Area()

    },

  }
}